/* eslint-disable indent */
import startDates, {
  EndOfWritingPeriod,
  StartDate,
  WritingPeriod,
} from '../utils/static-data/startDates'

const useNextStartDate = () => {
  const now = new Date()

  const currentWritingPeriod: WritingPeriod =
    startDates.find((wp) => new Date(wp.endOfWritingPeriod) > now) || null
  const nextStartDate: StartDate = currentWritingPeriod?.startDate || null

  return nextStartDate !== null
    ? new Date(nextStartDate).toLocaleDateString('en-us', {
        day: 'numeric',
        month: 'short',
        weekday: 'long',
        year: 'numeric',
      })
    : null
}

export default useNextStartDate
